import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Stack } from "@mui/material";
import MusicList from "../MusicList";
import NoData from "../Nodata";
import { useTranslation } from "react-i18next";

export default function FeatureBox({
  title,
  route,
  music,
  isArtist,
  isPlaylist,
  isMusic,
  actions,
  toggleMenu,
  isNft,
  isFeature,
  ownerRoyalty,
  isPlaylistNft,
  playSongs,
  isHome,
  hideIcons,
  isStreaming,
  onStream,
}) {
  const history = useHistory();
  const { t, i18n } = useTranslation("common");

  return (
    <Box sx={{ position: "relative", minHeight: "200px" }}>
      <Box
        mt="15px"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "20px !important" }}>
          {title}
        </Typography>
        <Typography
          sx={{ fontSize: "13px !important", cursor: "pointer" }}
          color="primary"
          onClick={() =>
            history.push(
              route
              //   , {
              //   state: {
              //     music: music,
              //     isArtist: isArtist,
              //     isMusic: isMusic,
              //     isPlaylist: isPlaylist,
              //   },
              // }
            )
          }
        >
          {t("home.explore")}
        </Typography>
      </Box>

      {music && music.length > 0 ? (
        <MusicList
          isArtist={isArtist}
          isPlaylist={isPlaylist}
          music={music}
          isMusic={isMusic}
          actions={actions}
          isNft={isNft}
          isFeature={isFeature}
          ownerRoyalty={ownerRoyalty}
          isPlaylistNft={isPlaylistNft}
          toggleMenu={(action, id, index) => toggleMenu(action, id, index)}
          playSongs={playSongs}
          isHome={isHome}
          hideIcons={hideIcons}
          isStreaming={isStreaming}
          onStream={(channelName) => onStream(channelName)}
        />
      ) : (
        <Box sx={{ position: "relative", minHeight: "100px" }}>
          <NoData lable={t("noData.noData")} />
        </Box>
      )}
    </Box>
  );
}
